module.exports = __webpack_public_path__ + "static/media/400123_02.61fdb99a.png";